import React from 'react';
import { PageBanner } from '../components/PageBanner';
import { Services } from '../components/Services';
import { HowItWorks } from '../components/HowItWorks';
export function ServicesPage() {
  return <main className="bg-white" data-id="element-571">
      <PageBanner title="Our Services" subtitle="Comprehensive fingerprinting solutions for every need, from employment to licensing." data-id="element-572" />
      <Services data-id="element-573" />
      <HowItWorks data-id="element-574" />
    </main>;
}